/**
 * useRevisionProgramState — navigation wrappers for Revision Program detail.
 * Parent legacy day items are not clickable — only close/back lives here.
 * No local UI state yet (no `useReducer`); add one when interaction state appears.
 */
import { useNavigation } from "@react-navigation/native"

export function useRevisionProgramState() {
    const navigation = useNavigation<{
        canGoBack: () => boolean
        goBack: () => void
        replace: (name: string) => void
    }>()

    const actions = {
        close() {
            if (navigation.canGoBack()) navigation.goBack()
            else navigation.replace("menu")
        },
    }

    return { actions }
}
